var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toaster',{on:{"close-toaster":_vm.closeSummaryToaster},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('span',[_vm._v("יעד riseup התעדכן")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }